// 基准大小
const baseSize = 16;


/**
 * 检测是否为移动设备
 */
function isMobileDevice()
{
    const userAgent = navigator.userAgent.toLowerCase();
    // console.log('=== common__isMobileDevice__window__innerWidth >>>', window.innerWidth);

    // 返回检测结果：符合约定规则 或者 设备宽度 小于等于768像素，则为移动设备
    return /iphone|ipad|ipod|android/.test(userAgent) || window.innerWidth <= 768;
}

// 设置 rem 函数
/* function setRem()
{
    // 当前页面宽度相对于1920宽的缩放比例，基准宽度可根据自己ui设计图修改。
    const scale = document.documentElement.clientWidth / 1440;
    // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
} */
function setRem()
{
    
    const screenWidth      = isMobileDevice() ? 750 : 1920;// 以1920分辨率为基准，将视口分为120份，每一份为16px，即1rem=16px
    const scale            = screenWidth / 16;
    const htmlWidth        = document.documentElement.clientWidth || document.body.clientWidth;
    // console.log('=== isMobileDevice >>>', isMobileDevice());
    // console.log('=== scale >>>', scale);
    // console.log('=== htmlWidth >>>', htmlWidth);
    const htmlDom          = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / scale + 'px';// 设置根元素字体大小
}

// 初始化
setRem();

// 监听窗口变化 改变窗口大小时重新设置 rem
window.onresize = function(){
    setRem();
}
